import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { WebphoneService, WebphoneQuery, CallingState } from '@etop/state/shop/webphone';
import { Observable, interval } from 'rxjs';
import { PageBaseComponent } from '@etop/web';
import { ConfigService } from '@etop/core';

@Component({
  selector: 'etelecom-cs-active-call',
  templateUrl: './active-call.component.html',
  styleUrls: ['./active-call.component.scss']
})
export class ActiveCallComponent extends PageBaseComponent implements OnInit, OnDestroy {

  @Output() playAudioUrl = new EventEmitter<string>();

  callingPhoneNumber$: Observable<string>;
  callingPhoneName$: Observable<string>;
  
  callDuration$: Observable<string>;
  callState$ = this.webphoneQuery.select(state => state.callState);
  
  isMuted = false;
  showDTMF = false;
  onRefer = false;
  onHold = false;

  callingTime = 0;
  callingTimeInterval: any;
  referNumber = "";
  crm_url: string;

  constructor(
    private webphoneService: WebphoneService,
    private webphoneQuery: WebphoneQuery,
    private config: ConfigService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.callingPhoneNumber$ = this.webphoneQuery.select(state => state.callingPhoneNumber);
    this.callingPhoneName$ = this.webphoneQuery.select(state => state.callingPhoneName);
    this.crm_url = this.config.get('crm_url');

    // Listen for call end
    this.callState$.subscribe(state => {
      switch (state) {
        case CallingState.callProcessing:
          if (!this.callingTimeInterval) {
            this.callingTimeInterval = setInterval((_) => {
              this.callingTime += 1;
            }, 1000);
          }
          break;
        case CallingState.none:
          this.callingTime = 0;
          if (this.callingTimeInterval) {
            clearInterval(this.callingTimeInterval);
            this.callingTimeInterval = null;
          }
          break;
      }})
  }

  ngOnDestroy(): void {
  }

  async hangup(): Promise<void> {
    try {
      await this.webphoneService.hangup();
    } catch (error) {
      toastr.error(error.message || 'Không thể kết thúc cuộc gọi');
    }
  }

  referToggle() {
    this.onRefer = !this.onRefer;
  }

  confirmRefer() {
    this.onRefer = false;
    this.webphoneService.confirmRefer(this.referNumber).then();
    this.referNumber = "";
  }

  toggleHold(): void {
    this.onHold = !this.onHold;
    this.webphoneService.holdToggle(this.onHold);
  }

  toggleMute(): void {
    this.isMuted = !this.isMuted;
    this.webphoneService.setLocalAudioMuted(this.isMuted);
  }

  sendDTMF(tone: string): void {
    this.webphoneService.sendDtmf(tone).catch(error => {
      console.error('Error sending DTMF:', error);
    });
  }

  resetActions() {
    this.showDTMF = false;
    this.onRefer = false;
    this.onHold = false;
    this.isMuted = false;
  }

  openTicket() {
    const ticketUrl = this.crm_url + encodeURIComponent(
      this.webphoneQuery.getValue().callingPhoneNumber
    )
    window.open(ticketUrl, "_blank");
  }
}

